
import React from 'react'

import { connect } from 'react-redux'

import actions from 'states/header/actions'

import styles from './search-button.module.scss'


const SearchButton = (props) => (
	<button className={styles.button} onClick={props.show}></button>
)

function mapStateToProps(state, props) {
	return {
	}
}

function mapDispatchToProps(dispatch) {
	return {
		show : () => dispatch(actions.showSearch())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchButton)